/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CoreBaseService } from '../core-base-service';
import { CoreApiConfiguration } from '../core-api-configuration';
import { CoreStrictHttpResponse } from '../core-strict-http-response';

import { CorePlanningDataDto } from '../models/core-planning-data-dto';
import { projectAggregatorControllerGetPlanningData } from '../fn/project-aggregator/project-aggregator-controller-get-planning-data';
import { ProjectAggregatorControllerGetPlanningData$Params } from '../fn/project-aggregator/project-aggregator-controller-get-planning-data';
import { projectAggregatorControllerGetScheduleData } from '../fn/project-aggregator/project-aggregator-controller-get-schedule-data';
import { ProjectAggregatorControllerGetScheduleData$Params } from '../fn/project-aggregator/project-aggregator-controller-get-schedule-data';
import { CoreScheduleDataDto } from '../models/core-schedule-data-dto';

@Injectable({ providedIn: 'root' })
export class CoreProjectAggregatorService extends CoreBaseService {
  constructor(config: CoreApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectAggregatorControllerGetScheduleData()` */
  static readonly ProjectAggregatorControllerGetScheduleDataPath = '/o2-core/project-aggregator/{tenant}/schedule';

  /**
   * Get schedule data for tenant.
   *
   * Returns aggregated data for schedule view including projects, users, tasks, and subtasks with optimized batch queries. Optionally filters by project manager.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectAggregatorControllerGetScheduleData()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectAggregatorControllerGetScheduleData$Response(params: ProjectAggregatorControllerGetScheduleData$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreScheduleDataDto>> {
    const obs = projectAggregatorControllerGetScheduleData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get schedule data for tenant.
   *
   * Returns aggregated data for schedule view including projects, users, tasks, and subtasks with optimized batch queries. Optionally filters by project manager.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectAggregatorControllerGetScheduleData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectAggregatorControllerGetScheduleData(params: ProjectAggregatorControllerGetScheduleData$Params, context?: HttpContext): Observable<CoreScheduleDataDto> {
    const resp = this.projectAggregatorControllerGetScheduleData$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CoreScheduleDataDto>): CoreScheduleDataDto => r.body)
    );
  }

  /** Path part for operation `projectAggregatorControllerGetPlanningData()` */
  static readonly ProjectAggregatorControllerGetPlanningDataPath = '/o2-core/project-aggregator/{tenant}/planning';

  /**
   * Get planning data for tenant.
   *
   * Returns aggregated data for planning view including projects and tasks with optimized batch queries. Optionally filters by project manager.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectAggregatorControllerGetPlanningData()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectAggregatorControllerGetPlanningData$Response(params: ProjectAggregatorControllerGetPlanningData$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CorePlanningDataDto>> {
    const obs = projectAggregatorControllerGetPlanningData(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get planning data for tenant.
   *
   * Returns aggregated data for planning view including projects and tasks with optimized batch queries. Optionally filters by project manager.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectAggregatorControllerGetPlanningData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectAggregatorControllerGetPlanningData(params: ProjectAggregatorControllerGetPlanningData$Params, context?: HttpContext): Observable<CorePlanningDataDto> {
    const resp = this.projectAggregatorControllerGetPlanningData$Response(params, context);
    return resp.pipe(
      map((r: CoreStrictHttpResponse<CorePlanningDataDto>): CorePlanningDataDto => r.body)
    );
  }

}
